






















































































import { Component, Prop, Vue } from 'vue-property-decorator'
import CommonClass from '@/app/module/common'
import DateClass from '@/app/module/date'
import MachineRentListApi from '@/app/model/api/machineRentListApi'
import Local from '@/app/module/local'

@Component
export default class WeedList extends Vue {
  private constantValue: any
  @Prop() private data!: any

  created () {
    this.constantValue = JSON.parse(Local.getConstantValue()!)
  }

  private displayValue (val: string|number) {
    return val !== null && val !== undefined ? val : '-'
  }

  private dateToStringYmd (date: any) {
    if (date !== null && date !== '') {
      let day = new Date(date)
      return DateClass.dateToStringYmd(day, '年月日')
    } else {
      return '-'
    }
  }

  private doMachineRent () {
    this.getMachineRentList()
  }

  /* 機械タイプの判定 */
  private judgmentMachineTypeId (typeName: string) {
    for (let i in this.constantValue.machine_types) {
      if (this.constantValue.machine_types[i].machine_type_name === typeName) {
        return this.constantValue.machine_types[i].machine_type_id
      }
    }
  }

  private getMachineRentList () {
    (async () => {
      const data = {
        word: '',
        order_name: 'created_at',
        sort: false,
        step: null,
        rent_status: 1,
        machine_type: this.judgmentMachineTypeId('除草'),
        field_id: this.data.field_id,
        page: 1
      }

      const result = await MachineRentListApi.getMachineRentList(data)

      if (result.isOk()) {
        if (result.getPayload().total_count === 0) {
          this.$store.commit('machineRentState/setInitialFieldId', this.data.field_id)
          this.$router.push('/machine-rent/create').catch(e => {})
        } else {
          // モーダル表示
          this.$emit('show-reload-modal')
        }
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'alert')
      }
    })()
  }
}

